import { cacheCompanyInfo, getCacheCompanyInfo } from '@/api/login'
import { chooseUserType } from '@/api/creatCompany'
import { getStoreList, StoreItem } from '@/api/store';
import { getStoreInfo } from '@/api/ccx'
import { downloadUrl } from '@/utils/util'
import store from '@/store'
import router from '@/router';
import { setCcxStore } from '@/views/information'

// 判断系统是否有记录上次进入店铺，若有，则直接进入上次店铺；若无，则进入选择店铺页
export async function enterSystem (from: string) {
  const { data: cacheCompanyInfo = null } = await getCacheCompanyInfo({ mobile: store.state.user.mobile })
  // 有店铺信息
  if (cacheCompanyInfo) {
    // 多店
    if (cacheCompanyInfo.companyId === 'multi_store') {
      const { data = [] } = await getStoreList({ registMobile: store.state.user.mobile })
      const multiStoreList = store.state.app.multiStoreList
      let localMultiStoreList = []
      // 初始化多店总览范围
      if (multiStoreList.length > 0) {
        localMultiStoreList = data.filter(item => multiStoreList.includes(item.companyId)).map(item => item.companyId)
      } else if (data.length > 0) {
        localMultiStoreList = data.map(item => item.companyId)
      }
      if (localMultiStoreList.length >= 2) {
        toMultiStore(localMultiStoreList)
      } else {
        // 进入选择店铺页
        enterSelectStorePage(from)
      }
    } else { // 单店
      const { data = [] } = await getStoreList({}, { opUser: cacheCompanyInfo.opUser })
      if (data.length) {
        toSingleStore(data[0], from)
      } else {
        // 进入选择店铺页
        enterSelectStorePage(from)
      }
    }
  } else {
    // 进入选择店铺页
    enterSelectStorePage(from)
  }
}

// 进入选择店铺页
function enterSelectStorePage (from: string) {
  router.replace({ path: '/selectStore', query: { from } })
}

// 缓存本次进入店铺信息到服务器
function cacheCompanyInfoFunc (storeInfo: StoreItem) {
  const params = {
    userId: storeInfo.userId,
    companyId: storeInfo.companyId,
    mobile: store.state.user.mobile
  }
  cacheCompanyInfo(params)
}

// 获取常常鲜微店信息
function getStoreInfoFunc (storeId: string) {
  getStoreInfo({ storeId }).then(res => {
    // 缓存常常鲜微店信息
    setCcxStore(res?.data || {})
  })
}

// 进入多店
function toMultiStore (localMultiStoreList: any) {
  store.commit('SET_IS_MULTI_STORE', true)
  store.commit('SET_MULTI_STORE_LIST', localMultiStoreList)
  store.dispatch('setUserId', store.state.user.firstUserId)
  store.dispatch('GetInfo', {
    ...store.state.user.info,
    userId: store.state.user.firstUserId,
    companyId: '',
    companyName: '',
    logoUrl: '',
    storeName: '',
    storeHeadPortrait: '',
    address: '',
    addressDtl: '',
    openOnlineStore: 0,
  })
  router.replace('/workbench')
  // 缓存本次进入店铺信息
  cacheCompanyInfoFunc({ userId: store.state.user.firstUserId, companyId: 'multi_store', companyName: '多店总览' } as StoreItem)
}

// 进入单店
async function toSingleStore (storeInfo: StoreItem, from: string) {
  const param = {
    oldUserId: store.state.user.firstUserId, // 登录账号userId，一级用户id（魏子皓要求）
    userId: storeInfo.userId // 新创建的公司对应的userId
  }
  chooseUserType(param).then((res) => {
    if (res.code === '000000') {
      store.dispatch('setCompanyId', storeInfo.companyId)
      store.dispatch('setCompanyName', storeInfo.companyName)
      store.dispatch('setUserId', storeInfo.userId)
  
      const logoUrl = window.location.origin + downloadUrl(storeInfo.storeHeadPortrait)
  
      // 处理多店数据
      store.commit('SET_IS_MULTI_STORE', false)
      store.commit('SET_MULTI_STORE_LIST', [])
  
      // 缓存信息
      store.dispatch('GetInfo', { ...storeInfo, logoUrl, ...res.data })
      // 进入工作台
      router.replace('/workbench')
      // 缓存本次进入店铺信息
      cacheCompanyInfoFunc(storeInfo)
      // 获取常常鲜微店信息
      getStoreInfoFunc(storeInfo.companyId)
    } else {
      // 进入选择店铺页
      enterSelectStorePage(from)
    }
  }).catch(() => {
    // 进入选择店铺页
    enterSelectStorePage(from)
  })
}